import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useBoolean } from "../../../hooks/use-boolean";
import useTable from "../../../hooks/use-table";
import { ActiveSystemService, CreateSystemService, DeleteSystemService, SystemsService } from "../../../services/systems";
import { enqueueSnackbar } from "notistack";
import { IPagination } from "../../../types/pagination";
import { ISystem, ISystemCreate } from "../../../types/system";
import { systemOrderOptions } from "../../../constants/system";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useSystemList = () => {

    // hooks
    const loading = useBoolean(true);
    const openCreateDialog = useBoolean();
    const table = useTable({
        defaultDirection: systemOrderOptions[0].direction,
        defaultSortBy: systemOrderOptions[0].sortBy
    });

    // states
    const [nameSystem, setNameSystem] = useState<string>('');
    const [systemsList, setSystemsList] = useState<IPagination<ISystem> | null>(null);

    // rhf
    const NewSystemSchema = Yup.object().shape({
        name: Yup.string().required('Informe o nome do sistema').max(255, 'O nome deve conter no máximo 255 caracteres'),
        link: Yup.string().required('Informe o link do sistema').max(255, 'O nome deve conter no máximo 255 caracteres'),
    });    

    const methods = useForm({
        resolver: yupResolver<ISystemCreate>(NewSystemSchema),
        defaultValues: {
            name: '',
            link: ''
        }
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
        reset,
    } = methods;

    // functions
    const getSystems = async () => {

        loading.onTrue();

        await SystemsService(nameSystem, table).then(resp => {
            setSystemsList(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.dtaa?.message || 'Ocorreu um erro');
        });

        loading.onFalse();

    }

    const onSubmit = handleSubmit(async (data: ISystemCreate) => {

        loading.onTrue();

        await CreateSystemService(data).then(resp => {
            enqueueSnackbar(resp.data.message);
            openCreateDialog.onFalse();
            reset({
                name: '',
                link: ''
            });
            getSystems();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    });

    const deleteSystem = async (id: number) => {

        loading.onTrue();

        await DeleteSystemService(id).then(resp => {
            enqueueSnackbar(resp.data.message);
            getSystems();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    }

    const activeSystem = async (id: number) => {

        loading.onTrue();

        await ActiveSystemService(id).then(resp => {
            enqueueSnackbar(resp.data.message);
            getSystems();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    }

    useEffect(() => {
        getSystems();
    }, [nameSystem, table.page, table.pageSize, table.direction, table.sortBy]);

    return {
        loading, 
        table,
        nameSystem,
        setNameSystem,
        systemsList,
        openCreateDialog,
        isSubmitting,
        methods,
        onSubmit,
        getSystems,
        activeSystem,
        deleteSystem
    }
}

export default useSystemList;